import { readCookie, createCookie } from '../../components/common/Cookie.js';
import { Cookies } from '../../constants';
// import { getFieldsFromDateAsFormat } from "../../utils";

export function getPincodeFromCookie() {
  return readCookie(Cookies.PINCODE);
}

export function setPincodeToCookie(pincode) {
  createCookie(Cookies.PINCODE, pincode, 180);
}

export function getServiceOrNonServicabilityItems(
  cartItem,
  eddDetails = {},
  activePincode,
  servicabilityStatus
) {
  const pincodeRelatedItems = cartItem.map(item => {
    const pincodeItems = eddDetails[activePincode] || {};
    const { eddLower, eddUpper, ...rest } = item;
    return {
      ...rest,
      ...(pincodeItems[item.code] || {})
    };
  });

  // Filter items based on servicability status and stock information
  return pincodeRelatedItems.filter(item => {
    const { stockInfo, servicability = false, isMembershipArticle } = item;

    // Case 1: When servicabilityStatus is false (non-servicable)
    if (servicabilityStatus === false) {
      // Include items that are membership articles AND have stock errors
      const hasStockError = stockInfo?.stockErrorDescription?.length > 0;
      const isMembershipItem = isMembershipArticle;

      if (hasStockError && isMembershipItem) {
        return true; // Include this item
      }
    }

    // Case 2: When servicabilityStatus is true (servicable)
    // OR when checking for specific servicability status
    if (servicability === servicabilityStatus) {
      return true; // Include this item
    }

    // If none of the conditions match, exclude this item
    return false;
  });
}

export function generateRandomId(length) {
  const characters = '0123456789';
  const cryptoObj = window.crypto || window.msCrypto; // for compatibility with IE
  const randomValues = new Uint32Array(length);
  cryptoObj.getRandomValues(randomValues);
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(randomValues[i] % characters.length);
  }
  return +result;
}
